
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Media Coverage</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm media section-banner-bg-1">
    <div class="container">
        <!-- <div class="sec-title text-center">
            <h2>Media <span> Coverage</span></h2>
        </div> -->
        <div class="gall-ery shadow-soft">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys">
                        <h4>MEDIA</h4>
                    </div>
                </div>

            </div>
            <div class="row  row-cols-1 row-cols-lg-4 ">
                <div class="col">
                    <a href="https://drive.google.com/file/d/1GAJq4LGi0rSCEwR7Z2JEOv1Unc7UAHMp/view" target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4> General Media </h4>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>

        <div class="gall-ery shadow-soft" id="media_classical">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys">
                        <h4>CLASSICAL CLONCALVE</h4>
                    </div>
                </div>

            </div>
            <div class="row row-cols-1 row-cols-lg-4 justify-content-left">
                <div class="col">
                    <a href="https://drive.google.com/file/d/1CboaM6ZCzmKWaRBgxnHrm9JchO5ffofx/view?usp=sharing"
                        target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Dance Nagpur Dance</h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1vRoJy8Oly0PvJByyCO2mS9ZAGVMf91Fz/view?usp=sharing"
                        target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Indian Classical Vocal Performance Nagpur</h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1kczNPjIrI0gSSt-K9ivAD52flDI7ifJd/view?usp=sharing"
                        target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Indian Classical Vocal Performance Amravati</h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1hAb306AnuHmPq0G89gp07kqDUimWwlUk/view?usp=sharing"
                        target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Naad Ninaad</h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1zIlOP0njRfR41QN2QFzaf9S3mYW4_7FR/view?usp=sharing"
                        target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4> Sawani Shende</h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1wDIzLGKC0v7epCHjOiUBbOxKFQTcyBag/view?usp=sharing"
                        target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4> Urvashi Shah</h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/12Yc4U3gFT2anozbmBILeA_pAi0fVkEP4/view?usp=sharing"
                        target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4> Lata Mangeshkar</h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1hjbgshthx8aUk4lWJLbbrylZaKur6a_y/view" target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4> Konkan Kanya</h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1x7AK4HUYlGOX7zOfeIACoJETxookIZOG/preview" target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Vidushi Kalapini Komkali </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1dDF3eNtbbCb09ajvnxQAUgUViUrh4n4b/view" target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Guru Smt. Priyanka Abhyankar </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1hzN3n3PZ3AA5itO9WrJq3i5qdR0koZSb/view" target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Manbhavan Ashadh </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1t9wnNMWMeuoD7yVn17epCBMt0nkfPQbr/view" target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Ms. Nirali Kartik (Surmayi Shyam) </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1yD9hA_n3UW0MWMUXe6bvzfcmoXxx0O0z/view?usp=sharing"
                        target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Shri. Bhupal Panshikar </h4>
                            </div>
                        </div>
                    </a>
                </div>

                <div class="col">
                    <a href="https://drive.google.com/file/d/1K_NgNhwihBdKWuTqB95VcpZl8qXMzuQP/view?usp=sharing"
                        target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Jugalbandi </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a
                        href="https://e.issuu.com/anonymous-embed.html?u=raisonigroupofinstitutions&d=culturalevent_22c0c508ce553c">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Pt. Devaki Pandit & Pt. Prasad Khaparde </h4>
                            </div>
                        </div>
                    </a>
                </div>

            </div>

        </div>

        <div class="gall-ery shadow-soft">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys">
                        <h4>SJAN MEDIA COVERAGE</h4>
                    </div>
                </div>

            </div>
            <div class="row  row-cols-1 row-cols-lg-4 ">
                <div class="col">
                    <a href="https://drive.google.com/file/d/107XVNDWPNfASBd3SRkVRhSJ8J9HB0J_y/view" target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>After Program 2019 </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1Q9YglgXi8CvuNpyyuW7Zmzjsf-nWEUou/view" target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>SJAN 2019</h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1StQ1X1d-NEDa_DAhS19zElKOSRW5SWuR/view?usp=sharing"
                        target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>SJAN 2018</h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/18ify4kjs5pj11q7CJI3uVHZeL_Ruc5xb/view?usp=sharing"
                        target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>SJAN 2017</h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1i6Low3Gn-8Xy08o5ysVs2gv0l9vfguGw/view?usp=sharing"
                        target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>SJAN 2016 </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/15ExRsVNiKv1tvlogkLkSu9y860c4nL8c/view?usp=sharing"
                        target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>SJAN 2015 </h4>
                            </div>
                        </div>
                    </a>
                </div>


            </div>

        </div>

        <div class="gall-ery shadow-soft" id="media_fidechess">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys">
                        <h4>FIDE CHESS COMPETITION MEDIA COVERAGE</h4>
                    </div>
                </div>

            </div>
            <div class="row  row-cols-1 row-cols-lg-4 ">
                <div class="col">
                    <a href="https://drive.google.com/file/d/1-SQAj_CVUp5ZbmZJtm6qNI7qKBiY7iIg/view?usp=sharing"
                        target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Fide Press Coverage 2023</h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1KJROgskveq1GgeklVdq0-kfNy4IJpK-K/view" target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Fide Press Coverage 2021</h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://drive.google.com/file/d/1soSsZ1f53h3aTB8iX68frJgkG4VthHGD/view" target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Fide Press Coverage 2019</h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://ghrscf.com/pdf/fide_chess_compitation.pdf" target="blank">
                        <div class="category-icon-title shadow-inset">

                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Fide Chess Competition 2018</h4>
                            </div>
                        </div>
                    </a>
                </div>


            </div>

        </div>

    </div>
</section>
